import React, { VFC } from 'react';

import { JourneyMenuPropsInterface } from 'src/common/JourneyMenu';
import { SmallPanel } from 'src/common/ui/small-panel';
import { JourneyTemplateForm } from 'src/dashboard/home/forms/journey-template-form';
import { useNotificationMessage } from 'src/common/notification/message.hook';
import { Journey } from 'src/common/interfaces/journey.interface';
import { useHistory } from 'react-router-dom';
import { useCurrentOrganization } from 'src/store/organization';
import { useFeatureRestrictions } from 'src/hooks/useFeatureRestrictions';
import { FreeGatingEnum, useFreeGatingStore } from 'src/common/free-gating/store';

export interface DashboardHomeCommonConfirmPanelProps
  extends Pick<
    JourneyMenuPropsInterface,
    'openRef' | 'closeRef' | 'placement' | 'offset' | 'renderOrigin' | 'onOpen' | 'onClose'
  > {
  onConfirm?: () => void;
  onDeny?: () => void;
  onBack?: () => void;
  containerClassName?: string;
  journey: Journey;
}

export const DashboardHomeConvertToOrganizationTemplatePanel: VFC<DashboardHomeCommonConfirmPanelProps> = ({
  onBack,
  containerClassName,
  journey,
  ...popoverProps
}) => {
  const history = useHistory();
  const { currentOrganization } = useCurrentOrganization();
  const { setSuccessNotification } = useNotificationMessage();
  const { features, showUpgradeModal } = useFeatureRestrictions();
  const setFreeGatingModalByType = useFreeGatingStore((state) => state.setFreeGatingModalByType);

  // Check if user has access to organization templates
  if (!features.canAccessOrganizationTemplates) {
    setFreeGatingModalByType(FreeGatingEnum.ORG_TEMPLATES, true);
    // Close the panel since user doesn't have access
    if (popoverProps.onClose) {
      popoverProps.onClose();
    }
    return null;
  }

  const onJourneyTemplateCreateSuccess = () => {
    history.push(`/${currentOrganization.slug}/library/organization-templates`);
    setSuccessNotification('Created the template successfully');
  };

  return (
    <SmallPanel openAfterMount hasBackButton onBack={onBack} containerClassName={containerClassName} {...popoverProps}>
      <div className="flex flex-col space-y-md">
        <JourneyTemplateForm journey={journey} onSuccess={onJourneyTemplateCreateSuccess} />
      </div>
    </SmallPanel>
  );
};
